// (B) 플레인 Col — antd Col 대체(순수 시각). antd 24-grid Col → flex-basis. `.om-col`/`.om-col-{span}` 미러링.
// span 지정 시 flex/max-width 를 (span/24*100)% 로 인라인 반영(소비처 style 이 우선). 소비처 SCSS
// (main/style.module `> .om-col:nth-child(N)` 등)가 실제 폭/flex 정의 → 여기선 base(styles/omCol.css)만.
import type { CSSProperties } from 'react'
import type { OmwColProps } from '../api/OmwCol'
import { cx } from './cx'
import '../styles/omwCol.css'

export function PlainCol({
  span,
  className,
  style,
  onClick,
  children,
  'data-testid': testid,
}: OmwColProps) {
  const spanStyle: CSSProperties =
    span != null ? { flex: `0 0 ${(span / 24) * 100}%`, maxWidth: `${(span / 24) * 100}%` } : {}

  return (
    <div
      className={cx('om-col', span != null && `om-col-${span}`, className)}
      style={{ ...spanStyle, ...style }}
      onClick={onClick}
      data-testid={testid}
    >
      {children}
    </div>
  )
}
